import { useState, useEffect } from "react";
import Unauthorized from "../Unauthorized/Unauthorized";


export async function getNewAccessToken(silent = false) {
    const refreshResponse = await fetch("/api/auth/refreshAccess", {
        method: "GET",
        credentials: "include",
    });
    if (refreshResponse.ok) {
        return true;
    }
    // Logout if refresh token is invalid, get rid of cookies
    const errorData = await refreshResponse.json();
    if (errorData?.error === "Log out") {
        // Logout the user by calling the backend logout endpoint to clear HTTP-only cookies
        await fetch("/api/auth/logout", {
            method: "DELETE",
            credentials: "include",
        });
        if (!silent) {
            alert("Your session has expired. Please log in again.");
            window.location.href = "/login"; // Redirect to login page
        }
    }
    return false;
}

export async function fetchAuthStatus() {
    const response = await fetch("/api/auth/verify", {
        method: "GET",
        credentials: "include", // Include cookies in the request
    });
    if (response.ok) {
        return { authenticated: true, ...await response.json() };
    } else {
        const errorData = await response.json();
        // Access token expired, try to refresh it
        if (errorData?.error === "Access token expired?") {
            return await getNewAccessToken(true);
        }
    }
    return false;
}

function ProtectedRoute({ children }) {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [checkingAuth, setCheckingAuth] = useState(false);


    useEffect(() => {
        const checkAuth = async () => {
            setCheckingAuth(true);
            try {
                const authStatus = await fetchAuthStatus();
                setIsAuthenticated(authStatus.authenticated);
            } catch (error) {
                console.error("Error checking authentication:", error);
                setIsAuthenticated(false);
            }
            setCheckingAuth(false);
        };

        checkAuth();
    }, []);

    if (checkingAuth) {
        return (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <h2>Checking authentication...</h2>
            </div>
        )
    }

    return isAuthenticated ? children : (
        <Unauthorized />
    );
}

export default ProtectedRoute;